import React from "react";
import { Button } from "@magicbi/ui-library";
import { useModalDialog } from "../../../hooks/useModalDialog";
import { DialogShell } from "../DialogShell";
import { List, Message, More } from "./ListConfirmDialog.styles";
import type { ListConfirmDialogProps } from "./ListConfirmDialog.types";

/** A confirm that lists the items it affects. */
export const ListConfirmDialog: React.FC<ListConfirmDialogProps> = ({
  open,
  title,
  message,
  items,
  maxItems = 8,
  moreLabel,
  confirmLabel,
  cancelLabel,
  closeLabel,
  tone = "default",
  onConfirm,
  onCancel,
}) => {
  const dialog = useModalDialog(open, onCancel);
  const hidden = Math.max(0, items.length - maxItems);
  return (
    <DialogShell
      open={open}
      size="sm"
      title={title}
      titleId="list-confirm-title"
      closeLabel={closeLabel}
      {...dialog}
      onClose={onCancel}
      footerEnd={
        <>
          <Button variant="secondary" onClick={onCancel}>
            {cancelLabel}
          </Button>
          <Button variant={tone === "danger" ? "danger" : "primary-dark"} onClick={onConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      <Message>{message}</Message>
      {items.length > 0 ? (
        <List>
          {items.slice(0, maxItems).map((item) => (
            <li key={item}>{item}</li>
          ))}
          {hidden > 0 && moreLabel ? <More>{moreLabel(hidden)}</More> : null}
        </List>
      ) : null}
    </DialogShell>
  );
};

export default ListConfirmDialog;
